var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolcano(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 82,
    viewBox: "0 0 80 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3454 0H49.6546L80 55H1L31.3454 0Z",
    fill: "url(#paint0_linear_1_5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.69384 81L30.9358 28H48.0642L77.3062 81H1.69384Z",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5",
    x1: -0.00807375,
    y1: 23.5023,
    x2: 102.284,
    y2: 37.4373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309653,
    stopColor: "#EA50E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#FAFF00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolcano);
export default __webpack_public_path__ + "static/media/volcano.0e1b97a9626ebfa1fbe9288e872d3de7.svg";
export { ForwardRef as ReactComponent };